import { render, staticRenderFns } from "./kwld.vue?vue&type=template&id=09f33c1c&scoped=true&"
import script from "./kwld.vue?vue&type=script&lang=js&"
export * from "./kwld.vue?vue&type=script&lang=js&"
import style0 from "./kwld.vue?vue&type=style&index=0&id=09f33c1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f33c1c",
  null
  
)

export default component.exports